import { DocumentNode } from '@apollo/client/core';
import { Kind } from 'graphql/language';
import { FragmentDefinitionNode } from 'graphql/language/ast';
import { addClientAlwaysDirective } from 'src/database/addClientAlwaysDirective.ts';

/**
 * workaround for removing duplicated fragment definitions at runtime
 * @TODO tune codegen to apply this workaround
 * @See more info on the issue and third party solution https://www.npmjs.com/package/gql-dedup
 * @param doc
 */
export function removeDuplicateFragments(doc: DocumentNode) {
    const usedFragments: Record<string, boolean> = {};

    return addClientAlwaysDirective({
        ...doc,
        definitions: doc.definitions.filter((def) => {
            const included = def.kind !== Kind.FRAGMENT_DEFINITION || !usedFragments[def.name.value];
            if (included) {
                usedFragments[(def as FragmentDefinitionNode).name.value] = true;
            }
            return included;
        }),
    });
}
